define('lib/view/BaseCollectionView',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Common collection view
     *
     * @class CollectionView
     */
    return Marionette.CollectionView.extend({

        _pageId: null,
        _moduleId: null,

        childEvents: {
            'dom:refresh': '_onChildDomRefresh'
        },

        _onChildDomRefresh: function () {
            if (this._pageId || this._moduleId) {
                this.triggerItemShown();
            }
        },

        onDomRefresh: function () {
            this.triggerMethod('items:shown');

            if (this._pageId || this._moduleId) {
                this.triggerItemsShown();
            }
        },

        triggerItemsShown: function () {
            var params = {};
            if (this._pageId) {
                params.page = this._pageId;
            }
            if (this._moduleId) {
                params.module = this._moduleId;
            }

            Backbone.Wreqr.radio.vent.trigger('items', 'shown', params);
        },

        triggerItemShown: function () {
            var params = {};
            if (this._pageId) {
                params.page = this._pageId;
            }
            if (this._moduleId) {
                params.module = this._moduleId;
            }

            Backbone.Wreqr.radio.vent.trigger('item', 'shown', params);
        }

    });

});
